// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multistep-form .on-board{display:block!important}.border-agv{border:2px solid #6bb545!important}input::-moz-placeholder{text-transform:none}input::placeholder{text-transform:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
